import React, { createContext, ReactElement, useState } from 'react';
import { AlertProps } from '@cloudscape-design/components';

export interface ToastMessage {
  header: string;
  description: ReactElement | string;
  type?: AlertProps.Type;
  dismissTime?: number;
  onDismiss?: () => void;
}

export const ToastMessageContext = createContext<{
  addToastMessage: (toast: ToastMessage) => void;
  toasts: ToastMessage[];
}>({
  addToastMessage: () => null,
  toasts: [],
});

export const ToastMessageContextProvider = ({
  children,
}: {
  children: ReactElement;
}) => {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);
  const addToastMessage = (toast: ToastMessage) => {
    setToasts([...toasts, toast]);
  };

  return (
    <ToastMessageContext.Provider value={{ toasts, addToastMessage }}>
      {children}
    </ToastMessageContext.Provider>
  );
};
